import { useDispatch, useSelector } from "react-redux";
import Table from "../ui/table/TableController";
import {
  companiesSelector,
  updateTax,
  updateTaxState,
} from "../../redux/slices/companiesSlice";
import { uiSelector } from "../../redux/slices/uiSlice";
import Loading from "./tableState/Loading";
import NoSearch from "./tableState/NoSearch";
import NoItems from "./tableState/NoItems";

const POS_SECTION = {
  background: "#eef4fd",
  color: "#346fcf",
  dividerColor: "#88aef5",
};

const PMS_SECTION = {
  background: "#f4effb",
  color: "#7b68b3",
  dividerColor: "#88aef5",
};

const Tax = () => {
  const { taxes, tableLoading } = useSelector(companiesSelector);
  const dispatch = useDispatch();
  const { searchQuery } = useSelector(uiSelector);

  const filteredTaxes = taxes.filter((i) => {
    const search = searchQuery.toLowerCase();

    return (
      String(i.tax_id || "").includes(search) ||
      i.tax_name?.toLowerCase().includes(search) ||
      String(i.pms_id || "").includes(search) ||
      i.pms_name?.toLowerCase().includes(search)
    );
  });

  const sectionHeaders = [
    {
      id: "pos",
      label: "POS",
      span: 3,
      background: POS_SECTION.background,
      color: POS_SECTION.color,
      dividerAfter: true,
      dividerColor: POS_SECTION.dividerColor,
    },
    {
      id: "pms",
      label: "PMS",
      span: 3,
      background: PMS_SECTION.background,
      color: PMS_SECTION.color,
    },
  ];

  const headerData = [
    {
      id: 132,
      label: "Company",
      width: "16%",
      sortable: false,
      sectionBackground: POS_SECTION.background,
    },
    {
      id: 232,
      label: "Id",
      width: "16%",
      sortable: true,
      sectionBackground: POS_SECTION.background,
    },
    {
      id: 342,
      label: "Name",
      width: "18%",
      sortable: true,
      sectionBackground: POS_SECTION.background,
      dividerAfter: true,
      dividerColor: POS_SECTION.dividerColor,
    },
    {
      id: 332,
      label: "PMS ID",
      width: "18%",
      sortable: true,
      sectionBackground: PMS_SECTION.background,
    },
    {
      id: 334,
      label: "PMS Name",
      width: "18%",
      sortable: true,
      sectionBackground: PMS_SECTION.background,
    },
    {
      id: 337,
      label: "Action",
      width: "14%",
      sortable: false,
      sectionBackground: PMS_SECTION.background,
    },
  ];

  const rowKeys = ["company_id", "tax_id", "tax_name", "pms_id", "pms_name"];

  const editable = ["pms_id", "pms_name"];

  const sortByData = [
    {},
    {
      label: "tax_id",
      type: "string",
    },
    {
      label: "tax_name",
      type: "string",
    },
    {
      label: "pms_id",
      type: "number",
    },
    {
      label: "pms_name",
      type: "string",
    },
  ];

  const updateAction = (x) => {
    dispatch(updateTaxState(x));
    return dispatch(updateTax(x));
  };

  if (tableLoading) return <Loading />;

  if (filteredTaxes.length === 0 && searchQuery) return <NoSearch />;
  if (filteredTaxes.length === 0) return <NoItems />;

  return (
    <Table
      sortByData={sortByData}
      headerData={headerData}
      sectionHeaders={sectionHeaders}
      rowKeys={rowKeys}
      data={filteredTaxes}
      editable={editable}
      row_key="tax_id"
      updateAction={updateAction}
    />
  );
};

export default Tax;
